import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "href", "isLast", "isActive", "isOpen", "isLargeOnly", "isSingle", "index", "onClick", "className", "data-test"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import * as Styled from './Breadcrumb.styles';
var META_DATA = {
  itemScope: true,
  itemProp: 'itemListElement',
  itemType: 'http://schema.org/ListItem'
};
export default (function (_ref) {
  var name = _ref.name,
      href = _ref.href,
      isLast = _ref.isLast,
      isActive = _ref.isActive,
      isOpen = _ref.isOpen,
      isLargeOnly = _ref.isLargeOnly,
      isSingle = _ref.isSingle,
      index = _ref.index,
      onClick = _ref.onClick,
      className = _ref.className,
      dataTest = _ref['data-test'],
      props = _objectWithoutProperties(_ref, _excluded);

  var linkProps = {
    className: 'xs-row xs-middle xs-nowrap',
    href: href,
    onClick: onClick,
    'aria-current': props['aria-current']
  };
  var metaData = props.metaData ? META_DATA : {};
  var itemProp = props.metaData ? {
    itemProp: 'item'
  } : {};
  return /*#__PURE__*/React.createElement(Styled.Item, _extends({
    isLast: isLast,
    isOpen: isOpen,
    isLargeOnly: isLargeOnly,
    isActive: isActive,
    isSingle: isSingle,
    key: name,
    className: className,
    "data-test": dataTest
  }, metaData), /*#__PURE__*/React.createElement(href ? Styled.Link : Styled.Span, _objectSpread(_objectSpread(_objectSpread({}, linkProps), itemProp), {}, {
    isLargeOnly: isLargeOnly
  }), [/*#__PURE__*/React.createElement(Styled.Chevron, {
    key: "svg",
    dir: "left"
  }), /*#__PURE__*/React.createElement("span", {
    key: "name",
    itemProp: "name"
  }, name)]), props.metaData && /*#__PURE__*/React.createElement("meta", {
    itemProp: "position",
    content: index
  }));
});